import { useGetDialCodesQuery } from "@/api/AppApi/services/company";
import { useEffect, useRef } from "react";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import { Col, Row } from "@/utils/bootstrap";
import SvgCodeSelected from "./SvgCodeSelected";
import { IDialCodeCountry } from "@/api/AppApi/services/company/interfaces/api-company-interfaces";
import Flag from "@/app/components/lib/Flag";

interface Props {
  dialCountryCode: IDialCodeCountry;
  code: string;
  form: UseFormReturn<FieldValues, any>;
  name: string;
  onSelect: () => void;
}

const searchcriteria = (country: IDialCodeCountry, code: string) =>
  country?.dial_code.startsWith(code.startsWith("+") ? code : "+" + code) ||
  country?.name.toUpperCase().startsWith(code?.toUpperCase());

const CountrieCodes: React.FC<Props> = ({
  form,
  name,
  code,
  dialCountryCode,
  onSelect,
}) => {
  const getDialCodes = useGetDialCodesQuery();
  const dialCodes = getDialCodes.data?.result;
  const selectedRef = useRef<any>(null);

  const isSelected = (code: string) => code === dialCountryCode?.dial_code;
  useEffect(() => {
    selectedRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);
  return (
    <div className="countries-codes">
      {dialCodes
        ?.filter((country) => searchcriteria(country, code))
        .map((country, index) => (
          <div
            key={index}
            ref={
              index > 9 && isSelected(country.dial_code) ? selectedRef : null
            }
          >
            {index > 0 && <div className="hor" />}
            <Controller
              name={name}
              control={form.control}
              render={({ field }) => (
                <Row
                  className="m-0 align-items-center country"
                  onClick={() => {
                    field.onChange(country);
                    onSelect();
                  }}
                >
                  <Col
                    className={`p-0 name-flag ${
                      isSelected(country.dial_code) ? "selected" : ""
                    }`}
                  >
                    <Flag countryCode={country.iso2} width={18} />
                    {country.name}
                    {isSelected(country?.dial_code) && <SvgCodeSelected />}
                  </Col>
                  <Col className="p-0 col-auto code d-flex justify-content-end">
                    <bdi>{country?.dial_code}</bdi>
                  </Col>
                </Row>
              )}
            />
          </div>
        ))}
    </div>
  );
};
export default CountrieCodes;
